import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ProjectDetailsService } from '../../../project-details.service';

@Component({
    selector: 'app-activity-ids-list-side-nav-screen',
    templateUrl: './activity-ids-list-side-nav-screen.component.html',
    styleUrls: ['./activity-ids-list-side-nav-screen.component.scss'],
    standalone: false
})
export class ActivityIdsListSideNavScreenComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private projectDetailsService: ProjectDetailsService,
  ) {
  }

  ngOnInit() {
    this.projectDetailsService.disableAddMenu.next(true);

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
